import { Fragment, useEffect } from "react";
import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { Apps, Tasks } from "../../../Constants/Constants";
import { useAppDispatch } from "../../../ReduxToolkit/Hooks";
import { fetchTaskApiData, setActiveTab } from "../../../ReduxToolkit/Reducers/TaskSlice";
import NavClass from "./NavClass/NavClass";
import TabClass from "./TabClass/TabClass";

const TaskContainer = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchTaskApiData());
  }, [dispatch]);
  const activeToggle = (tab: string) => dispatch(setActiveTab(tab));

  return (
    <Fragment>
      <Breadcrumbs mainTitle={Tasks} parent={Apps} />
      <Container fluid>
        <div className="email-wrap bookmark-wrap">
          <Row>
            <NavClass activeToggle={activeToggle} />
            <TabClass />
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default TaskContainer;
